__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ta-chat-assistant-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/icons-material", "5.18.0", () => (Promise.all([__webpack_require__.e(734), __webpack_require__.e(61), __webpack_require__.e(710), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(5061))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(734), __webpack_require__.e(995), __webpack_require__.e(330), __webpack_require__.e(552), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(934), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(6552))))));
			register("@securitize/reactjs-whm", "1.7.0", () => (Promise.all([__webpack_require__.e(734), __webpack_require__.e(995), __webpack_require__.e(330), __webpack_require__.e(548), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(934), __webpack_require__.e(230), __webpack_require__.e(493), __webpack_require__.e(817)]).then(() => (() => (__webpack_require__(3548))))));
			register("@tanstack/react-query", "5.90.21", () => (Promise.all([__webpack_require__.e(228), __webpack_require__.e(710), __webpack_require__.e(198)]).then(() => (() => (__webpack_require__(7228))))));
			register("axios", "1.16.0", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(5526))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(475), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(442)]).then(() => (() => (__webpack_require__(5475))))));
			register("react-router", "6.30.3", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(216), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(835))))));
			register("react-transition-group", "4.4.5", () => (Promise.all([__webpack_require__.e(949), __webpack_require__.e(710), __webpack_require__.e(334), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(3330))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};